// billing-plugin/common/schemas/collections/subscriptionEvents.js
import { z } from "zod";

const SubscriptionEventSchema = z.object({
    _id: z.string().optional(),
    subscriptionId: z.string().describe("The ID of the subscription the event occurred on."),
    
    eventType: z.enum([
        'STATUS_CHANGED',
        'CREDIT_LIMIT_CHANGED',
        'BALANCE_RECHARGED',
        'PLAN_MIGRATED',
        'DISCOUNT_APPLIED',
        'PACK_APPLIED'
    ]),
    
    description: z.string().describe("A human-readable summary of the event."),
    
    // Context of who performed the action
    actorType: z.enum(['admin', 'user', 'system']),
    actorId: z.string().describe("The userId of the admin or user who performed the action."),
    actorName: z.string().describe("The username or name of the actor."),
    
    // Detailed metadata about the event
    metadata: z.record(z.any()).optional().describe("Event-specific data, e.g., { oldStatus: 'active', newStatus: 'cancelled' }."),
    
    createdAt: z.coerce.date(),
});

export default SubscriptionEventSchema;